var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxCrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3511 3.46796C8.2709 3.35339 8.13985 3.28516 8 3.28516C7.86015 3.28516 7.7291 3.35339 7.6489 3.46796L4.94184 7.33519L2.73162 5.12497C2.60905 5.0024 2.42471 4.96573 2.26456 5.03206C2.10442 5.0984 2 5.25467 2 5.42801V10.9994C2 11.4541 2.18061 11.8901 2.5021 12.2116C2.82359 12.5331 3.25963 12.7137 3.71429 12.7137H12.2857C12.7403 12.7137 13.1764 12.5331 13.4979 12.2116C13.8194 11.8901 14 11.4541 14 10.9994V5.42801C14 5.25467 13.8956 5.0984 13.7354 5.03206C13.5753 4.96573 13.3909 5.0024 13.2683 5.12497L11.0582 7.33519L8.3511 3.46796Z",
    fill: "#F87800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxCrown);
export default __webpack_public_path__ + "static/media/icon_16px_crown.a59bf034cbf070572f9ccc8dc250c5a2.svg";
export { ForwardRef as ReactComponent };